import { render, staticRenderFns } from "./DeliveryStepHeadToReceiver.vue?vue&type=template&id=7a9350fb&"
import script from "./DeliveryStepHeadToReceiver.vue?vue&type=script&lang=js&"
export * from "./DeliveryStepHeadToReceiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports